// Formatos colombianos, los pocos que el panel necesita: pesos con punto de miles y fechas en hora de Bogotá.
const miles = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 0 });

export function pesos(v: unknown): string {
  const n = Number(v);
  if (!Number.isFinite(n)) return '—';
  return `${n < 0 ? '−' : ''}$${miles.format(Math.abs(n))}`;
}

export function fechaCorta(iso: string): string {
  return new Intl.DateTimeFormat('es-CO', { day: 'numeric', month: 'short', timeZone: 'UTC' }).format(new Date(`${iso.slice(0, 10)}T12:00:00Z`));
}

export function momento(ts: string | Date): string {
  return new Intl.DateTimeFormat('es-CO', { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit', timeZone: 'America/Bogota' }).format(new Date(ts));
}

// «Hace cuánto» dicho como lo diría una persona: es lo que el equipo mira para ver qué negocio se está apagando.
export function desde(ts: string | Date | null): string {
  if (!ts) return 'Nunca';
  const dias = Math.floor((Date.now() - new Date(ts).getTime()) / 86_400_000);
  return dias === 0 ? 'Hoy' : dias === 1 ? 'Ayer' : `Hace ${dias} días`;
}
